module.exports = "/media/star-face-of-day.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/tools/images/face-a-day/star-face-of-day.png
// module id = 288
// module chunks = 0